var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCommentsIconGreen(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "32520931-EAA1-4890-A45C-9B799579E801") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Walk-in/out",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Site-level-entrance-Copy",
    transform: "translate(-220.000000, -304.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "main-panel",
    transform: "translate(79.000000, 64.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "human-id",
    transform: "translate(13.000000, 47.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "comments",
    transform: "translate(128.000000, 193.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#5f00a0",
    x: 0,
    y: 0,
    width: 40,
    height: 40,
    rx: 3.33333333
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(10.000000, 7.777778)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.2307692,10.8974359 L14.2307692,9.1025641 L3.54700855,9.1025641 L3.54700855,10.8974359 L14.2307692,10.8974359 Z M14.2307692,13.5683761 L14.2307692,11.7735043 L3.54700855,11.7735043 L3.54700855,13.5683761 L14.2307692,13.5683761 Z M14.2307692,16.2393162 L14.2307692,14.4444444 L3.54700855,14.4444444 L3.54700855,16.2393162 L14.2307692,16.2393162 Z M17.7777778,7.30769231 L17.7777778,23.3333333 L14.2307692,19.7863248 L1.75213675,19.7863248 C1.26780385,19.7863248 0.854702564,19.6082639 0.512820513,19.2521368 C0.170938462,18.8960096 -2.0250468e-13,18.4757859 -2.0250468e-13,17.991453 L-2.0250468e-13,7.30769231 C-2.0250468e-13,6.8233594 0.170938462,6.41025812 0.512820513,6.06837607 C0.854702564,5.72649402 1.26780385,5.55555556 1.75213675,5.55555556 L16.025641,5.55555556 C16.5099739,5.55555556 16.9230752,5.72649402 17.2649573,6.06837607 C17.6068393,6.41025812 17.7777778,6.8233594 17.7777778,7.30769231 Z",
    id: "\\uE8B5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(16.666667, -0.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "3.98724083 0 3.98724083 2.67942584 6.66666667 2.67942584 6.66666667 3.98724083 3.98724083 3.98724083 3.98724083 6.66666667 2.67942584 6.66666667 2.67942584 3.98724083 0 3.98724083 0 2.67942584 2.67942584 2.67942584 2.67942584 0"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentsIconGreen);
export default __webpack_public_path__ + "static/media/comments_icon_green.588ea3bafbdfb4e4921751812ed00682.svg";
export { ForwardRef as ReactComponent };